export const STATUS_ID = 'resolvableMissionTypeStatus';
